import type { GridMap } from "../generation/GridMap";
import { TileType, pointKey, type Point } from "../generation/types";

export function exploredNearbyCells(grid: GridMap, start: Point, radius = 2): Set<string> {
  const visible = new Set<string>();
  if (!grid.isWalkable(start, false)) return visible;
  const queue = [{ point: start, distance: 0 }];
  visible.add(pointKey(start));
  for (let index = 0; index < queue.length; index += 1) {
    const { point, distance } = queue[index]!;
    if (distance >= radius) continue;
    for (const next of grid.neighbors4(point)) {
      const key = pointKey(next);
      if (
        visible.has(key) ||
        grid.get(next) === TileType.SecretDoor ||
        !grid.canTraverse(point, next)
      )
        continue;
      visible.add(key);
      if (grid.isWalkable(next, false)) queue.push({ point: next, distance: distance + 1 });
    }
  }
  return visible;
}
